<!-- Linear Progress Bar -->
@if (type === 'linear') {
<div class="space-y-2">
  <!-- Label and percentage -->
  @if (showLabel || showPercentage) {
  <div class="flex justify-between items-center text-sm">
    @if (showLabel && label) {
    <span class="font-medium text-gray-700 dark:text-gray-300">{{ label }}</span>
    }
    @if (showPercentage) {
    <span class="text-gray-600 dark:text-gray-400">{{ roundedPercentage() }}%</span>
    }
  </div>
  }

  <!-- Progress bar container -->
  <div [class]="computedBarClasses()" [attr.role]="'progressbar'" [attr.aria-valuenow]="value"
    [attr.aria-valuemin]="min" [attr.aria-valuemax]="max" [attr.aria-label]="label">
    <!-- Progress fill -->
    <div [class]="computedFillClasses()" [style.width.%]="percentage()">
      <!-- Shimmer effect -->
      <div class="absolute inset-0 overflow-hidden rounded-full">
        <div class="absolute inset-0 bg-linear-to-r from-transparent via-white/30 to-transparent
                          transform -skew-x-12 animate-shimmer opacity-60"></div>
      </div>

      <!-- Premium floating particles -->
      @if (variant === 'premium') {
      <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-60 rounded-full">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-white/80 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/4 right-1/3 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse delay-300"></div>
      </div>
      }

      <!-- Indeterminate animation -->
      @if (indeterminate) {
      <div class="absolute inset-0 bg-linear-to-r from-transparent via-white/40 to-transparent
                          animate-indeterminate rounded-full"></div>
      }
    </div>
  </div>

  <!-- Buffer/secondary progress -->
  @if (bufferValue !== undefined) {
  <div class="absolute inset-0 rounded-full">
    <div class="h-full bg-current opacity-20 rounded-full transition-all duration-500"
      [style.width.%]="bufferPercentage()"></div>
  </div>
  }
</div>
}

<!-- Circular Progress -->
@if (type === 'circular') {
<div class="relative inline-flex items-center justify-center">
  <svg [attr.width]="circularSize" [attr.height]="circularSize" class="transform -rotate-90"
    [attr.viewBox]="'0 0 ' + circularSize + ' ' + circularSize">
    <!-- Background circle -->
    <circle [attr.cx]="circularSize / 2" [attr.cy]="circularSize / 2" [attr.r]="radius()"
      [class]="circularTrackClasses()" fill="none" [attr.stroke-width]="strokeWidth" />

    <!-- Progress circle -->
    <circle [attr.cx]="circularSize / 2" [attr.cy]="circularSize / 2" [attr.r]="radius()"
      [class]="circularProgressClasses()" fill="none" [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="circumference()" [attr.stroke-dashoffset]="strokeDashoffset()"
      [style.transition]="'stroke-dashoffset 0.5s ease-in-out'" />
  </svg>

  <!-- Center content -->
  @if (showPercentage || label) {
  <div class="absolute inset-0 flex items-center justify-center">
    <div class="text-center">
      @if (showPercentage) {
      <div class="text-sm font-semibold text-gray-900 dark:text-white">
        {{ roundedPercentage() }}%
      </div>
      }
      @if (label) {
      <div class="text-xs text-gray-600 dark:text-gray-400 mt-0.5">
        {{ label }}
      </div>
      }
    </div>
  </div>
  }
</div>
}